import { useQueryClient } from "@tanstack/react-query";
import {
  TrailerEvent,
  useAddTrailerEventMutation,
  useDeleteTrailerEventMutation,
  useEditTrailerEventMutation,
  useTrailerEventsQuery,
} from "../../../graphql/generated";
import TrailerEventFormModal from "./TrailerEventFormModal";
import { omit } from "lodash";

export default function TrailerEventFormModalContainer({
  trailerEvent,
  onClose,
  isOpen,
  trailerId,
}: {
  trailerEvent?: TrailerEvent | null;
  onClose: () => Promise<void>;
  isOpen: boolean;
  trailerId: string;
}) {
  const queryClient = useQueryClient();
  const addTrailerEventMutation = useAddTrailerEventMutation();
  const editTrailerMutation = useEditTrailerEventMutation();
  const deleteTrailerEventMutation = useDeleteTrailerEventMutation();

  return (
    <TrailerEventFormModal
      trailerEvent={trailerEvent}
      onClose={onClose}
      onSaveTrailerEvent={async (trailerInput) => {
        try {
          if (trailerEvent?._id) {
            await editTrailerMutation.mutateAsync({
              id: trailerEvent._id,
              editTrailerEventData: { ...omit(trailerInput, "_id"), trailerId },
            });
          } else {
            await addTrailerEventMutation.mutateAsync({
              newTrailerEventData: {
                ...trailerInput,
                trailerId,
              },
            });
          }
          await queryClient.invalidateQueries(useTrailerEventsQuery.getKey());
          await onClose();
        } catch (error) {
          console.error(error);
        }
      }}
      onDeleteTrailerEvent={async (id) => {
        try {
          await deleteTrailerEventMutation.mutateAsync({ id });
          await queryClient.invalidateQueries(useTrailerEventsQuery.getKey());
          await onClose();
        } catch (error) {
          console.error(error);
        }
      }}
      loading={
        addTrailerEventMutation.isLoading ||
        editTrailerMutation.isLoading ||
        deleteTrailerEventMutation.isLoading
      }
      isOpen={isOpen}
      error={
        addTrailerEventMutation.error ||
        editTrailerMutation.error ||
        deleteTrailerEventMutation.error
      }
    />
  );
}
